export default __webpack_public_path__ + "static/media/14.002b0da3.jpg";